module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/other/site-d65fcd3db1233f186446d63ebfd0a1ea.webmanifest";